// Define the enum
export enum FeatureFlagName {
  Tour = 'tour',
  Subtitles = 'subtitles',
  OpenEndedQuestion = 'openEndedQuestion',
  LessonFromDocument = 'lessonFromDocument',
  EditVideoOptions = 'editVideoOptions',
  RecordVideo = 'recordVideo',
}

type FeatureFlagsState = {
  [key in FeatureFlagName]: boolean;
};

class FeatureFlags {
  private flags: FeatureFlagsState = {
    [FeatureFlagName.Tour]: false,
    [FeatureFlagName.Subtitles]: false,
    [FeatureFlagName.OpenEndedQuestion]: false,
    [FeatureFlagName.LessonFromDocument]: false,
    [FeatureFlagName.EditVideoOptions]: false,
    [FeatureFlagName.RecordVideo]: false,
  };

  get(flagName: FeatureFlagName): boolean {
    return this.flags[flagName];
  }

  set(flagName: FeatureFlagName, value: boolean): void {
    this.flags[flagName] = value;
    console.log(
      `[FeatureFlags] ${flagName} is ${value ? 'ENABLED' : 'DISABLED'}`,
    );
  }

  toggle(flagName: FeatureFlagName): boolean {
    const newValue = !this.get(flagName);
    this.set(flagName, newValue);
    return newValue;
  }

  getAll(): FeatureFlagsState {
    return {...this.flags};
  }
}

// Export a singleton instance if needed
const featureFlags = new FeatureFlags();
export default featureFlags;
